import setSiteMeta from '../base-saving-actions/set-site-meta';

const createCurrentButtonPresetVersion = (version) =>
  setSiteMeta(['customization', 'currentButtonPresetVersion'], version);

export default createCurrentButtonPresetVersion;
